import axios from 'axios'
import { host } from '../../helper/config'
import { ITEM_PER_PAGE } from '../../helper/helper'

const PLUGINS_NAME = 'admin-mua-chung'

// GET LIST CHARGE
export const getListCartGroup = async (token, query, page) => {
    const response = await axios.post(
        `${host}/${PLUGINS_NAME}/get-list`,
        {
            ...query,
            page: page,
            itemPerPage: ITEM_PER_PAGE,
        },
        {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': token
            },
        }
    )

    if (response && response.status === 200) {
        return response.data.data || {}
    }
    return {}
}

// GET CART GROUP DETAIL
export const getCartGroupDetail = async (token, id) => {
    const response = await axios.post(
        `${host}/${PLUGINS_NAME}/get-detail`,
        { id },
        {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': token
            },
        }
    )

    if (response && response.status === 200) {
        return response.data || {}
    }
    return { error: 1, message: 'Có lỗi xảy ra' }
}

// GET CONTRIBUTE VALUES (for create form)
export const getContributeValues = async (token, payload = {}) => {
    const response = await axios.post(
        `${host}/${PLUGINS_NAME}/get-contribute-values`,
        payload,
        {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': token
            },
        }
    )

    if (response && response.status === 200 && response.data && response.data.error === 0) {
        return response.data.data || []
    }
    return []
}

// CREATE CART GROUP
export const createCartGroup = async (token, payload) => {
    const response = await axios.post(
        `${host}/${PLUGINS_NAME}/create`,
        payload,
        {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': token
            },
        }
    )

    if (response && response.status === 200) {
        return response.data || {}
    }
    return { error: 1, message: 'Có lỗi xảy ra' }
}

// REFUND CART GROUP (hủy nhóm & hoàn tiền cho tất cả)
export const refundCartGroup = async (token, cartGroupId) => {
    const response = await axios.post(
        `${host}/${PLUGINS_NAME}/refund`,
        { cartGroupId },
        {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': token
            },
        }
    )

    if (response && response.status === 200) {
        return response.data || {}
    }
    return { error: 1, message: 'Có lỗi xảy ra' }
}

// REFUND SELECTED TRANSACTIONS (hoàn tiền giao dịch đã chọn)
export const refundTransactions = async (token, cartGroupId, transactionIds) => {
    const response = await axios.post(
        `${host}/${PLUGINS_NAME}/refund-transactions`,
        { cartGroupId, transactionIds },
        {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': token
            },
        }
    )

    if (response && response.status === 200) {
        return response.data || {}
    }
    return { error: 1, message: 'Có lỗi xảy ra' }
}

// DISTRIBUTE REWARD
export const distributeReward = async (token, cartGroupId) => {
    const response = await axios.post(
        `${host}/${PLUGINS_NAME}/distribute-reward`,
        { cartGroupId },
        {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': token
            },
        }
    )

    if (response && response.status === 200) {
        return response.data || {}
    }
    return { error: 1, message: 'Có lỗi xảy ra' }
}

// REMOVE CART GROUP (only inactive/status 0)
export const removeCartGroup = async (token, id) => {
    const response = await axios.post(
        `${host}/${PLUGINS_NAME}/remove`,
        { id },
        {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': token
            },
        }
    )

    if (response && response.status === 200) {
        return response.data || {}
    }
    return { error: 1, message: 'Có lỗi xảy ra' }
}

// UPDATE CART GROUP (activate/deactivate)
export const updateCartGroup = async (token, id, status) => {
    const response = await axios.post(
        `${host}/${PLUGINS_NAME}/update`,
        { id, status },
        {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': token
            },
        }
    )

    if (response && response.status === 200) {
        return response.data || {}
    }
    return { error: 1, message: 'Có lỗi xảy ra' }
}

// export const getSummaryCharge = async (token, query, endPointId) => {
//     const response = await axios.post(`${host}/${PLUGINS_NAME}/get-summary-charge`, {
//         ...query,
//         endPointId: endPointId
//     }, {
//         headers: {
//             'Access-Control-Allow-Origin': '*',
//             'Content-Type': 'application/json',
//             'Authorization': token
//         },
//     })

//     if (response && response.status === 200) {
//         return response.data || {}
//     }
//     return null
// }

// export const getCsvCharge = async (token, query, page, totalPage) => {
//     const response = await axios.post(`${host}/${PLUGINS_NAME}/get-csv-charge`, {
//         ...query,
//         page: page,
//         itemPerPage: ITEM_PER_PAGE,
//         totalPage: totalPage
//     }, {
//         headers: {
//             'Access-Control-Allow-Origin': '*',
//             'Content-Type': 'application/json',
//             'Authorization': token
//         },
//     })
    
//     if (response && response.status === 200) {
//         return response.data || {}
//     }
//     return null
// }

// // ADD CHARGE
// export const addCharge = async (token, chargeValue, chargeMethod, accountId, phone, referenceNumber) => {
//     const response = await axios.post(
//         `${host}/${PLUGINS_NAME}/add-charge`,
//         {
//             chargeValue: chargeValue,
//             chargeMethod: chargeMethod,
//             accountId: accountId,
//             userId: phone,
//             referenceNumber: referenceNumber.trim() === '' ? new Date().getTime().toString() : referenceNumber
//         },
//         {
//             headers: {
//                 'Access-Control-Allow-Origin': '*',
//                 'Content-Type': 'application/json',
//                 'Authorization': token
//             },
//         }
//     )

//     if (response && response.status === 200) {
//         return response.data
//     }
//     return null
// }

// export const getListIssueCharge = async (token, query, page) => {
//     const response = await axios.post(
//         `${host}/${PLUGINS_NAME}/get-list-charge-issue`,
//         {
//             ...query,
//             page: page,
//             itemPerPage: ITEM_PER_PAGE
//         },
//         {
//             headers: {
//                 'Access-Control-Allow-Origin': '*',
//                 'Content-Type': 'application/json',
//                 'Authorization': token
//             },
//         }
//     )

//     if (response && response.status === 200) {
//         return response.data || {}
//     }
//     return {}
// }

// export const deleteIssueCharge = async (token, id) => {
//     const response = await axios.post(
//         `${host}/${PLUGINS_NAME}/delete-charge-issue`,
//         {
//             id: id
//         },
//         {
//             headers: {
//                 'Access-Control-Allow-Origin': '*',
//                 'Content-Type': 'application/json',
//                 'Authorization': token
//             },
//         }
//     )

//     if (response && response.status === 200) {
//         return response.data || {}
//     }
//     return {}
// }
